var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderGallery',{attrs:{"img_header":_vm.header_image,"header":"คลังรูปภาพที่ส่งให้ลูกค้า (Photos sent to customer gallery)","detail_header":"10","end_header":"รูป (Photos)","link_back":"gallery","check_link_back":"1"}}),_c('PhotosSentToCustomerGallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }